var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.val)+" "),_c('i',{staticClass:"el-icon-copy-document",on:{"click":_vm.fun_copy}})])
}
var staticRenderFns = []

export { render, staticRenderFns }